export enum enEnviroment {
  DEV = 'development',
  HOMOLOG = 'homolog',
  PROD = 'production'
}
